<template>
  <div class="sidebar-logo-container" :class="{'collapse':true}">
    <transition name="sidebarLogoFade">
      <div class="sidebar-logo-container flex align-center justify-center cursor-pointer" @click="gotoBase">
        <img
          src="@/assets/list/logo.png"
          class="sidebar-logo"
          alt=""
        >
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  data() {
    return {
      title: this.$store.getters['setting/getTitle']
    }
  },
  watch: {
    imgUrl(val, oldVal) {
      this.imgUrl = val
    }
  },
  methods: {
    gotoBase() {
      this.$router.push('/base/home')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: $topBG;
  color: #ffffff;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      vertical-align: middle;
      width: 173px;
      padding-top: 10px;
      padding-left: 20px;
      height: 32px;
      position: absolute;
      top: -18px;
      left: -14px;
    }

    & .sidebar-title {
      display: inline-block;
      line-height: 40px;
      margin-left: 10px;
      color: #fff;
      font-weight: 600;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }
}
</style>
